export type AngleMode = '15deg' | '1deg';

// 根据x,y以及宽高计算角度和最大的top,left
export function getNewAngleByEvent(e: MouseEvent | React.MouseEvent, wrapRef: HTMLDivElement, angleMode: AngleMode) {
    if (!wrapRef) {
        return;
    }
    try {
        const center = getCenter(wrapRef.clientWidth);
        const { clientX, clientY } = e;
        const rect = wrapRef.getClientRects()[0];
        const { x, y } = rect;
        // 中心点坐标
        const centerP = { x: x + center.x, y: y + center.y };
        // 计算弧度
        const nx = clientX - centerP.x;
        const ny = clientY - centerP.y;
        const radian = Math.atan2(ny, nx);
        const angle = radianToAngle(radian);

        let resultAngle = angle;
        if (angleMode === '15deg') {
            resultAngle = Math.floor(angle / 15) * 15 + (angle % 15 > 7 ? 15 : 0);
            if (resultAngle === 360) resultAngle = 0;
        }

        return resultAngle;
    } catch (error) {
        return;
    }
}

export function getCenter(width: number, borderWidth: number = 1) {
    return {
        x: width / 2 - borderWidth,
        y: width / 2 - borderWidth,
    };
}

export function radianToAngle(radian: number): number {
    const angle = Math.round((radian * 180) / Math.PI);
    if (angle < 0) {
        return 360 + angle;
    }
    return angle;
}

export function angleToRadian(angle: number): number {
    return (angle * Math.PI) / 180;
}

// export function getRotatedPosition(angle: number, width: number) {
//   const center = getCenter(width);
//   const radian = angleToRadian(angle);
//   const x = Math.round(Math.cos(radian) * center.x);
//   const y = Math.round(Math.sin(radian) * center.y);
//   return {
//     x,
//     y,
//   };
// }

export function getRotatedPosition(angle: number, width: number) {
    const center = getCenter(width);
    const startPoint = getStartPoint(width);
    const radian = angleToRadian(angle);
    const x = Math.round(
        Math.cos(radian) * (startPoint.x - center.x) - Math.sin(radian) * (startPoint.y - center.y) + center.x,
    );
    const y = Math.round(
        Math.sin(radian) * (startPoint.x - center.x) + Math.cos(radian) * (startPoint.y - center.y) + center.y,
    );
    // const x = Math.round(Math.cos(radian) * (startPoint.x - center.x)) + center.x;
    // const y = Math.round(Math.sin(radian) * (startPoint.x - center.x)) + center.y;
    return { x, y };
}

export function getStartPoint(width: number, circleWidth: number = 8, borderWidth: number = 1) {
    return {
        x: width - circleWidth / 2 - borderWidth * 2,
        y: width / 2 - borderWidth,
    };
}
